const comments = [
  {
    id: 1,
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20user%20avatar%20portrait%20of%20a%20young%20Asian%20woman%20with%20warm%20smile%2C%20soft%20cinematic%20lighting%2C%20clean%20neutral%20background%2C%20professional%20headshot%20style&width=160&height=160&seq=avatar-user-01&orientation=squarish',
    text: '用了爱看影院快两年了，免费电影资源真的多到看不完！更新速度也很快，基本上大热的剧当天就能看到，画质也清晰，强烈推荐给所有追剧的朋友！',
    time: '3天前',
  },
  {
    id: 2,
    name: '电影发烧友老张',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20user%20avatar%20portrait%20of%20a%20middle-aged%20Asian%20man%20with%20glasses%2C%20friendly%20expression%2C%20soft%20studio%20lighting%2C%20clean%20warm%20background%2C%20professional%20headshot%20style&width=160&height=160&seq=avatar-user-02&orientation=squarish',
    text: '作为一个资深影迷，我几乎每天都会打开爱看影院浏览新片。科幻片和悬疑片的分类做得很细，找到喜欢的类型非常方便。最重要的是全程免费，不用注册就能看！',
    time: '1周前',
  },
  {
    id: 3,
    name: '小花的周末',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20user%20avatar%20portrait%20of%20a%20young%20Asian%20woman%20with%20long%20hair%2C%20gentle%20smile%2C%20warm%20natural%20lighting%2C%20clean%20soft%20background%2C%20professional%20headshot%20style&width=160&height=160&seq=avatar-user-03&orientation=squarish',
    text: '周末宅家必备！韩剧和综艺更新的特别及时，画质清晰不卡顿，用手机看体验也很好。已经推荐给了好几个闺蜜，大家都说好用～',
    time: '2周前',
  },
  {
    id: 4,
    name: '片荒终结者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20user%20avatar%20portrait%20of%20a%20young%20Asian%20man%20with%20confident%20smile%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background%2C%20professional%20headshot%20style&width=160&height=160&seq=avatar-user-04&orientation=squarish',
    text: '告别片荒！爱看影院的精选推荐栏目每次都给我惊喜，发现了很多之前错过的好电影。热门话题区也很有趣，能看到大家都在讨论什么。完全免费，追剧党的福音！',
    time: '3周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              用户口碑
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              来自全国影迷的真实观影评价，品质值得信赖
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {comments.map((comment) => (
              <article
                key={comment.id}
                className="bg-background-800/50 border border-background-700/30 rounded-xl p-6"
              >
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex-shrink-0 rounded-full overflow-hidden border-2 border-primary-500/25">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="text-sm text-foreground-100 font-semibold">{comment.name}</h3>
                      <span className="text-xs text-foreground-500">{comment.time}</span>
                    </div>
                    <p className="text-sm text-foreground-300 leading-relaxed">{comment.text}</p>
                    <div className="flex items-center gap-1 mt-3">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-xs text-primary-400"></i>
                      ))}
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="text-center mt-10">
            <div className="inline-flex items-center gap-6 text-sm text-foreground-400">
              <span><strong className="text-foreground-200">4.9</strong> 综合评分</span>
              <span className="text-foreground-600">|</span>
              <span><strong className="text-foreground-200">50万+</strong> 忠实用户</span>
              <span className="text-foreground-600">|</span>
              <span><strong className="text-foreground-200">98%</strong> 好评率</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}